import type { ReactNode } from 'react'
import type { SessionRole } from '../lib/api.js'

/**
 * Wraps the Admin panel.
 *
 * By the time this renders the visitor is already signed in — sign-in happens at
 * the app level. All this decides is whether the session is ADMIN or merely
 * Wave9 staff. A staff session can quote, and can work as any partner, but the
 * settings behind this gate change every partner at once.
 *
 * ⚠️ This is a courtesy, not the control. Every admin endpoint checks the
 * session's role itself (`isAdminRequest`) — hiding a page in React protects
 * nobody who can open a network tab.
 */
export function AdminGate({ role, children }: { role: SessionRole | null; children: ReactNode }) {
  if (role !== 'admin') {
    return (
      <div className="page-head">
        <div>
          <h1>Admin only</h1>
          <p>
            You're signed in as Wave9 staff, which covers quoting and working as a partner.
            Partners, people, Product Line pricing and scheduled jobs need the admin key —
            sign out and sign back in as Wave9 admin.
          </p>
        </div>
      </div>
    )
  }

  return (
    <>
      <div className="banner" style={{ background: '#e6f4ee', borderColor: '#bfe3d2', color: '#0f7b52' }}>
        <strong>Wave9 admin.</strong>
        <span style={{ flex: 1 }}>Changes here affect every partner.</span>
        {/* Decision 243: a page may put its way back here (Billing's "← Queue") — filled through a portal. */}
        <span id="admin-banner-aside" />
      </div>
      {children}
    </>
  )
}
